export default {
  message: {
    Tour: {
      continue: "Продовжити",
      back: "Назад",
      finish: "Готово"
    },
    Login: {
      title: "Вхід для батьків",
      sign_in: "Увійти",
      login_fail:
        "Помилка автентифікації. Спробуйте ще раз або зверніться до школи за допомогою.",
      forgot_password: "Забули пароль",
      create_account: "Створити обліковий запис",
      password: "Пароль",
      confirm_password: "Підтвердіть пароль",
      password_reminder: "Нагадування пароля",
      enter_email: "Введіть вашу електронну адресу",
      validation_error: "Повідомлення про помилку валідації",
      password_reminder_error_no_user_register:
        "Користувача не знайдено. Спробуйте ще раз або створіть новий обліковий запис.",
      password_reminder_error_no_user: "Користувача не знайдено.",
      password_reminder_sent: "Лист з інструкціями надіслано на {email}.",
      password_reminder_sent_message:
        "Лист може надійти протягом кількох хвилин. Перевірте папку «Спам».",
      password_trouble_email: "Якщо проблема зберігається, зв'яжіться з {email}.",
      password_trouble_school:
        "Якщо проблема зберігається, зверніться до школи за допомогою.",
      return_to_sign_in: "Повернутися до входу",
      create_my_account: "Створити обліковий запис",
      or_sign_in_with: "АБО УВІЙТИ ЗА ДОПОМОГОЮ",
      password_reset: "Оберіть новий пароль для вашого облікового запису.",
      password_reset_warning:
        "Якщо ви не запитували зміну пароля, негайно зв'яжіться з адміністратором школи.",
      password_update: "Оберіть новий пароль",
      password_update_confirm: "Підтвердіть новий пароль",
      password_update_success: "Ваш новий пароль збережено."
    },
    AccountSettings: {
      title: "Налаштування облікового запису",
      first_name: "Ім'я",
      last_name: "Прізвище",
      email: "Email",
      username: "Ім'я користувача",
      password: "Пароль",
      students: "Учні",
      teachers: "Вчителі",
      external_id: "Зовнішній ID",
      phone: "Номер телефону",
      phone_required: "Номер телефону обов'язковий",
      edit: "Редагувати",
      remove: "Видалити",
      add: "Додати",
      remove_message: "Видалити цього учня?",
      yes: "Так",
      no: "Ні",
      add_student: "Додати учня",
      close: "Закрити",
      save: "Зберегти",
      cancel: "Скасувати",
      student_alert_message: "Необхідно вказати хоча б одного учня.",
      logout: "Вийти"
    },
    Navbar: {
      my_meetings: "Мої зустрічі",
      language: "Українська",
      help: "Допомога",
      account_settings: "Налаштування облікового запису",
      logout: "Вийти"
    },
    SubNavbar: {
      meeting: "Зустріч",
      event: "Подія",
      print: "Друк",
      email: "Email",
      export: "Експорт"
    },
    ConferenceCard: {
      add_edit_meetings: "Додати/змінити зустрічі",
      opening: "Відкрито",
      closed: "Закрито"
    },
    Agenda: {
      full_agenda: "Повний порядок денний",
      empty_state_title: "Для вас немає запланованих конференцій.",
      empty_state_message: "За питаннями звертайтесь до школи.",
      confirmation_modal_title: "Порядок денний підтверджено",
      confirmation_modal_message:
        "Порядок денний підтверджено. Вам надіслано листа на email.",
      complete_button: "Готово!"
    },
    AgendaCard: {
      room: "Кімната недоступна",
      room_with_value: "Кімната: {room}",
      virtual_meeting: "Онлайн-зустріч",
      all_conferences: "Всі конференції",
      conference: "Конференція",
      student: "Учень",
      meeting_with: "Зустріч з",
      date_time: "Дата/час",
      meeting_type: "Тип зустрічі",
      location: "Місце",
      comment: "Коментар",
      action: "Дія",
      delete: "Видалити",
      add_comment: "Додати коментар",
      join: "Приєднатися",
      choose_meeting_type: "Оберіть тип зустрічі",
      in_person: "Особисто",
      phone: "Телефон",
      callback: "Передзвон",
      virtual: "Онлайн",
      unavailable: "Недоступно",
      tooltip_translator:
        "Послуги перекладача не гарантовані, але школа докладе всіх зусиль для їх надання.",
      translator_requested: "Запрошено перекладача",
      clear_translator: "Скасувати запит перекладача",
      need_translator: "Потрібен перекладач?",
      choose_language: "Оберіть мову"
    },
    ScheduleMatrix: {
      no_teachers_title: "Вчителі або команди не обрані.",
      no_teachers_message: "Оберіть вчителя для перегляду часу зустрічей.",
      choose_teachers_button: "Переглянути доступних вчителів",
      choose_student: "Для якого учня?",
      cancel: "Скасувати"
    },
    Matrix: {
      teachers: "Вчителі",
      agenda: "Перевірити та продовжити"
    },
    DrawerTeachers: {
      teachers: "Вчителі",
      name: "Ім'я",
      description: "Опис",
      student: "Учень",
      teacher_team: "Вчитель/команда",
      show_more: "Показати ще",
      show_all: "Показати всіх вчителів школи",
      selected: "({count}) обрано",
      closeDrawer: "Продовжити планування",
      search: "Пошук вчителя або команди",
      not_available: "У цього вчителя немає доступного часу на {date}."
    },
    DrawerAgenda: {
      no_meetings_title: "У вас немає запланованих зустрічей.",
      no_meetings_message: "Після вибору вчителя та часу зустріч з'явиться тут.",
      new_meeting_label: "Нова",
      cancel_button: "Скасувати",
      student_label: "Учень",
      meeting_type_location: "Тип зустрічі/місце",
      comment_label: "Коментар",
      save_comment_button: "Зберегти",
      confirm_label: "Підтвердіть:",
      confirm_cancel_button: "Так, скасувати зустріч з ",
      do_not_cancel_button: "Не скасовувати",
      confirm_agenda_button: "Підтвердити порядок денний",
      confirm_agenda_message_line1: "Ви завжди можете повернутися та змінити.",
      confirm_agenda_message_line2: "Порядок денний буде надіслано вам на email."
    },
    EmailConsent: {
      message:
        "Для захисту вашої конфіденційності необхідно підтвердити отримання повідомлень на вашу електронну адресу.",
      consent: "Згоден"
    }
  }
};
